import * as React from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { useDispatch, useSelector } from 'react-redux'
import { obtenermovpercepcion, obtenermovdeduccion, obtenermovincidencias, obtenermovmov } from '../../../../../Redux/PdimIncidenciasDucks'
import { useState } from 'react';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

export interface DialogTitleProps {
    id: string;
    children?: React.ReactNode;
    onClose: () => void;
}

function BootstrapDialogTitle(props: DialogTitleProps) {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

export default function DetalleIncidenciaFechas(props) {
    const dispatch = useDispatch()
    const [open, setOpen] = useState(false);
    const { obtener } = props
    const { idmovimiento } = props || ['']
    const { data } = props

    const incidencias = useSelector(store => store.pdimov.dataincidencias)
    const fechas = incidencias.fechas || ['']
    let text = ''

      for (let i = 0; i < idmovimiento.length; i++) {
  
          if (idmovimiento[idmovimiento.length - 1] === idmovimiento[i])
              text += `idmovtosdyh[${i}]=${idmovimiento[i]}`
          else {
              text += `idmovtosdyh[${i}]=${idmovimiento[i]}&`
          }
      } 
  
    React.useEffect(() => {
        const obtenerDatos = async () => {
            dispatch(obtenermovincidencias(text))
        }
        obtenerDatos()

    }, [dispatch])

    const handleClickOpen = (e) => {
        e.preventDefault()
        setOpen(true);
        dispatch(obtenermovincidencias(text))
    };
    const handleClose = () => {
        setOpen(false);
    };

  

    return (
        <>
            <IconButton onClick={handleClickOpen}  size='small'>
                <RemoveRedEyeIcon />
            </IconButton>

            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}
            >
                <BootstrapDialogTitle id="customized-dialog-title" >
                    Detalles
                </BootstrapDialogTitle>
                <DialogContent dividers>
                    <Typography variant='h4'>Fechas:</Typography>
                    {
                        fechas.map((row, Index) =>
                            <li key={Index} style={{ fontSize: '25px' }}>{row}</li>
                        )
                    }
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={handleClose}>
                        Cerrar
                    </Button>
                </DialogActions>
            </BootstrapDialog>
        </>
    );
}